var map = {
	"./number-0.png": 3826,
	"./number-1.png": 4955,
	"./number-2.png": 1456,
	"./number-3.png": 8361,
	"./number-4.png": 5286,
	"./number-5.png": 4303,
	"./number-6.png": 9044,
	"./number-7.png": 173,
	"./number-8.png": 6106,
	"./number-9.png": 1315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 827;